﻿(function ($) {
    function hoverEvent() {
    }

    $(function () {
        $(document).on("mouseover", "[data-upsell]", hoverEvent);
    });
})(jQuery);


const History = window.History; // Note: We are using a capital H instead of a lower h


function changeSupplier() {
    const data = getData(1);
    const queryString = buildUpQueryString(data);
    if (queryString != "") {
        History.pushState(data, $('title').html(), "/suppliers/" + buildUpQueryString(data) + "/");
    } else {
        History.pushState(data, $('title').html(), "/suppliers/" + buildUpQueryString(data));
    }
    //History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

function getPage(href) {
    const querystring = href.split('?')[1];
    const parts = querystring.split('&');
    return $.grep(parts, function (el, index) {
        return el.split('=')[0] == "page";
    })[0].split('=')[1];
}


function pageData(event) {
    if ($(event.target).attr('href') === undefined)
        return false;
    const page = getPage($(this).attr('href'));
    const data = getData(page);
    //History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
    const queryString = buildUpQueryString(data);
    if (queryString !== "")
        History.pushState(data, $('title').html(), "/suppliers/" + queryString + "/");
    else
        History.pushState(data, $('title').html(), "/suppliers/");

    const top = $("html").offset().top;
    $('html,body').animate({
        scrollTop: top
    }, 350);

    return false;
}

function getData(page) {
    const categories = $('.supplier-categories-container input[name="Categories"]:checked').map(function (index, element) {
        return $(element).val();
    }).toArray();

    return {
        Categories: categories.join(','),
        Page: page
    };
}

function buildUpQueryString(data) {
    if (data.Categories.length == 0 && data.Page <= 1)
        return "";

    let queryString = "";

    if (data.Categories.length > 0) {
        queryString += data.Categories;
    }

    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "/";
        queryString += data.Page;
    }

    return queryString;
}


function updateState() { // Note: We are using statechange instead of popstate
    const State = History.getState();
    $.get('/Apps/FleetNews/supplier-zone/query', State.data, function (response) {
        $('[data-supplier-query]').replaceWith(response);
    });
    $.get('/Apps/FleetNews/supplier-zone/results', State.data, function (response) {
        $('[data-supplier-results]').replaceWith(response);
    });
}


export function setupSupplierZone() {
    const page = $('[data-supplier-zone]').length;
    if (!page) {
        return;
    }
    
    $(document).on('change', '.supplier-categories-container input', changeSupplier);
    $(document).on('click', '[data-supplier-results] .pagination a', pageData);

    //Bind to StateChange Event
    History.Adapter.bind(window, 'statechange', updateState);

}